import React from 'react';
import { useBrsCreateStyles } from '../BrsCreateStyles';

export const IsciStatusBadge = ({ exists }) => {
  const classes = useBrsCreateStyles();

  if (exists === undefined || exists === null) return null;

  return exists ? (
    <span className={`${classes.badge} ${classes.badgeExisting}`}>EXISTING</span>
  ) : (
    <span className={`${classes.badge} ${classes.badgeNew}`}>NEW</span>
  );
};
